<template>
    <div id="importOrder">
        <div class="yto-table">
            <div class="btn-group">
                <el-button @click="importOrder" type="primary">全部导入</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" max-height="720" :row-class-name="tableRowClassName" v-loading='loading'>
                <el-table-column
                  prop="" type="index" width="60"
                  align="center"
                  label="序号"
                  :resizable="false">
                    <template slot-scope="scope">
                        {{limit * (pageNo - 1) + scope.$index + 1}}
                    </template>
                </el-table-column>
                <el-table-column label="错误信息">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" :content="scope.row.errorContent" placement="top">
                      <span style="color: red;">{{scope.row.errorContent}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="receiveName" label="收件人姓名" align="left"></el-table-column>
                <el-table-column prop="receiveAddress" label="收件人地址" align="left"></el-table-column>
                <el-table-column prop="receiveMobile" label="收件人手机" align="left"></el-table-column>
                <el-table-column prop="receivePhone" label="收件人固话" align="left"></el-table-column>
                <el-table-column prop="sendName" label="发件人姓名" align="left"></el-table-column>
                <el-table-column prop="sendAddress" label="发件人地址" align="left"></el-table-column>
                <el-table-column prop="sendMobile" label="发件人手机" align="left"></el-table-column>
                <el-table-column prop="sendPhone" label="发件人固话" align="left"></el-table-column>
                <el-table-column prop="productName" label="商品名称" align="left"></el-table-column>
                <el-table-column prop="productNumbers" label="数量" align="left"></el-table-column>
                <el-table-column prop="productCode" label="产品类型" align="left">
                  <template slot-scope="scope">
                    {{scope.row.productCode == 'YZD' ? '圆准达' : '普快'}}
                  </template>
                </el-table-column>
                <el-table-column prop="incrementName" label="增值服务" align="left"></el-table-column>
                <el-table-column prop="remark" label="备注" align="left">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" :content="scope.row.remark" placement="top">
                      <span>{{scope.row.remark}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="logisticNo" label="客户订单号" align="left"></el-table-column>
                <el-table-column label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button @click="editOrder(scope)" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteOrder(scope)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
            @size-change="limitChange"
            @current-change="pageChange"
            :current-page.sync="pageNo"
            :page-sizes="[100, 300, 500]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next"
            :total="total">
            </el-pagination>

            <!-- <div class="countTips">共&nbsp;{{tableData.length}}&nbsp;条记录，第&nbsp;{{errorDataIndex.join(',')}}&nbsp;条导入格式不正确</div> -->
        </div>
        <!-- 编辑订单弹窗 -->
        <el-dialog title="编辑订单" :visible.sync="editDialogVisible" width="980px" :close-on-click-modal="false" @close="editDialogVisible=false">
          <order-info :data="rowData" :disabled="false" @closeDialog="closeDialog" @save="save" v-if="editDialogVisible"></order-info>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api/retrievalOrder.js';
import orderInfo from '@/views/retrievalOrder/OrderInfo.vue';
import {replaceOrderSaveApi} from '@/api/retrievalOrder';
export default {
  name: 'importOrder',
  components: {
    'order-info': orderInfo
  },
  data() {
    return {
      userCode: this.$store.state.user.userName,
      allData: [],
      tableData: [],
      editDialogVisible: false,
      editDialog: false,
      rowData: {},
      errorDataIndex: [],
      limit: 100,
      pageNo: 1,
      total: 0,
      editIndex: -1,
      loading: false
    };
  },
  mounted() {
    if (this.$route.params.items) {
      this.initTableList(this.$route.params.items);
    }
  },
  methods: {
    initTableList(list) {
      this.allData = [...list.fail, ...list.ok];
      this.allData.forEach(r => {
        try {
          let incrementName = '';
          if (r.increments?.length) {
            let incrementList = r.increments || [];
            let newNameList = [];
            incrementList.forEach(increment => {
              newNameList.push(`${increment.name}(${increment.amount})`);
            });
            incrementName = newNameList.join(','); // Changed from incrementList = newNameList.join(',');
          }
          r.incrementName = incrementName;
        } catch (error) {
          console.log(error)
        }
      });
      this.total = this.allData.length;
      this.splitPage(this.allData);
    },
    tableRowClassName({row, rowIndex}) {
      if (row.formatStatus === 0) {
        return 'error-row';
      }
      return '';
    },
    // 全部导入
    importOrder() {
      console.log("importOrder")
      if (this.allData) {
        let errFlag = false;
        this.allData.forEach(r => {
          this.$set(r,'userCode',this.userCode)
          this.$set(r,'channel','A')
          if (r.errorContent) {
            errFlag = true;
          }
        });
        if (errFlag) {
          this.$message.warning('还有错误条目未修改！');
          return false;
        }
      }
      this.loading = true;
      replaceOrderSaveApi(this.allData).then(res => {
        this.loading = false;
        if (res.status === '0') {
          this.$message.success(res.message);
          this.allData = [];
          this.$nextTick(() => {
            this.$router.push({name: 'RetrievalOrder', params: {flag: true}});
          });
        } else {
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err);
      });
    },
    editOrder({row, $index}) {
      let index = this.limit * (this.pageNo - 1) + $index;
      this.editIndex = index;
      this.rowData = JSON.parse(JSON.stringify(row));
      delete this.rowData.tag;
      delete this.rowData.errorContent;
      this.editDialogVisible = true;
      this.editDialog = true;
    },
    closeDialog() {
      this.editDialog = false;
      this.editDialogVisible = false;
    },
    // 编辑保存
    save(row) {
      // 这里需要格式化一下当前行的增值服务值
      try {
        let incrementName = '';
        if (row.increments?.length) {
          let incrementList = row.increments || [];
          let newNameList = [];
          incrementList.forEach(increment => {
            newNameList.push(`${increment.name}(${increment.amount})`);
          });
          incrementName = newNameList.join(','); // Changed from incrementList = newNameList.join(',');
        }
        row.incrementName = incrementName;
      } catch (error) {
        console.log(error)
      }
      this.$set(this.allData, this.editIndex, {...row, ...{formatStatus: 1}});
      this.splitPage(this.allData);
      this.editDialogVisible = false;
    },
    deleteOrder({row, $index}) {
      this.$confirm('确定要删除该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let index = this.limit * (this.pageNo - 1) + $index;
        this.$delete(this.allData, index, row);
        this.total = this.allData.length;
        this.pageNo = 1;
        this.splitPage(this.allData);
      });
    },
    limitChange(limit) {
      this.pageNo = 1;
      this.limit = limit;
      this.splitPage(this.allData);
    },
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.splitPage(this.allData);
    },
    // 分页，每页要展示的数据
    splitPage(data) {
      let resultData = [...data];
      let pageNo = this.pageNo;
      let pageLimit = this.limit;
      this.tableData = resultData.slice((pageNo - 1) * pageLimit, pageNo * pageLimit);
    }
  }
};
</script>

<style lang="scss">
  #importOrder {
    .el-table .cell {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .el-dialog {
      .el-dialog__header {
        padding: 10px;
        .el-dialog__headerbtn {
          top: 10px;
        }
      }
      .el-dialog__body {
        padding: 20px;
        color: #A2A5AC;
        font-size: 12px;
      }
    }
    .el-table .error-row {
      background: #ffe3fd;
    }
    .countTips {
      padding: 10px 30px;
      font-size: 14px;
      color: #ED7625;
    }
  }
</style>
